<template>
	<div class="flex flex-col-reverse sm:flex-row w-full items-center justify-center mt-32 md:mt-10 mb-20">
		<img
			class="w-full max-w-[160px] sm:max-w-[300px] sm:mr-4"
			src="https://res.cloudinary.com/djbs/image/upload/v1657114358/content/DreamJobs/Graphics/pic_no-result.svg"
			alt="No Result"
		/>

		<div class="flex flex-col mb-4 sm:mb-0 sm:ml-4">
			<p class="text-center sm:text-left text-xl sm:text-3xl font-semibold mb-4">{{ $t("noResult.title") }}</p>
			<p class="text-center sm:text-left text-lg sm:text-xl">{{ $t("noResult.description") }}</p>
			<p class="text-center sm:text-left text-lg sm:text-xl my-4">{{ $t("user.notifications.jobsCta") }}</p>
			<NuxtLink :to="isAuth ? `/${locale}/user/notifications` : `/${locale}/jobnotification`" target="_blank">
				<BaseButton class="mt-5 md:mt-0" type="secondary-red" size="small" rounded>
					<BaseIcon icon="mdi:bell-outline" color="#E1415A" class="mr-[10px] text-[24px]" />
					{{ $t("user.notifications.create") }}
				</BaseButton>
			</NuxtLink>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "NoResult",
	setup() {
		const { locale } = useI18n({
			useScope: "global",
		});
		const isAuth = useState("isAuth");

		return {
			locale,
			isAuth,
		};
	},
});
</script>
